import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { Tab, Header } from "semantic-ui-react";
import DailyWorkList from "./DailyWorkList";
import { useParams } from "react-router-dom";
const WorkListNewFormat = () => {
  const [rowData, setrowData] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // Initialize with the desired default tab index (e.g., 0 for visaCategoryId: 0)
  const { catId } = useParams();
  const color = "blue";
  useEffect(() => {
    getWorkCatList();
  }, [catId]);

  const getWorkCatList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listWorkCategory", { workCategory: "" })
      .then((res) => {
        console.log("res", res.data);

        const tempArr = [...rowData];
        // setrowData(res.data);

        for (let i = 0; i < res.data.length; i++) {
          tempArr.push({
            categoryId: res.data[i].categoryId,
            openingBalance: res.data[i].openingBalance,
            workCategory: res.data[i].workCategory,
          });
        }
        tempArr.push({
          categoryId: 0,
          openingBalance: 0,
          workCategory: "All",
        });

        if (catId != "null") {
          const indexToSetActive = tempArr.findIndex(
            (item) => item.categoryId === Number(catId)
          );
          setActiveTabIndex(indexToSetActive);
        }
        setrowData(tempArr);
      })
      .catch((error) => console.log(error));
  };

  const handleTabChange = (e, { activeIndex }) => {
    console.log("cat id", activeIndex);
    setActiveTabIndex(activeIndex); // Update the active tab index when a tab is clicked
  };

  const panes = rowData.map((item, index) => ({
    menuItem: `${item.workCategory}`,
    render: () => (
      <Tab.Pane attached={false} key={index}>
        <DailyWorkList categoryId={item.categoryId} />
        {/* <NewCompanyForm
          companyDetailList={companyDetailList[index]}
          indexVal={index}
        /> */}
      </Tab.Pane>
    ),
  }));
  return (
    <div>
      <Header dividing size="huge" as="h1">
        Daily Work List
      </Header>
      <Tab
        menu={{ color, attached: false, tabular: false }}
        panes={panes}
        activeIndex={activeTabIndex} // Set the active tab index
        onTabChange={handleTabChange} // Handle tab change events
      />
    </div>
  );
};

export default WorkListNewFormat;
